// Contract Address
export const MUMBAI_TTOTMAIN_ADDR = '0xd54bbe64512960Dc409A9532108F6Cf3E15DFe2B';
export const MUMBAI_RAFFLE_ADDR = '0x5f9Bf7fd91c037F52E6BD89d1e59697770211492';
// export const MUMBAI_TTOT = '';
// export const POLYGON_TTOT = '';

// NFTStorage 사용법
// https://velog.io/@donggni0712/reactJS%EC%97%90%EC%84%9C-nft.storage%EB%A1%9C-URI%EB%A7%8C%EB%93%A4%EA%B8%B0
// 에러 해결
// https://stackoverflow.com/questions/70063600/cant-resolve-ipfs-car-blockstore-memory-when-importing-nft-storage
export const NFTStorageName = 'ttot';
export const NFTStorageAPI =
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJkaWQ6ZXRocjoweEQ1MTkyODE0MzdENDVjREUyODY1NDAwYTYwODRhYTY1NkNCQWI4MTgiLCJpc3MiOiJuZnQtc3RvcmFnZSIsImlhdCI6MTY3MDI1OTQyMjQxNCwibmFtZSI6InR0b3QifQ.tbeR3TH-c1ZC2fx25eX5sGSeWrwYS3k9mTNSveh0oOU';
